import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {catchError, switchMap} from 'rxjs/operators';
import {from, of} from 'rxjs';
import {LoadError} from '@app/core/store/actions/error.actions';
import {
	DeleteSupplementalSalary,
	DeleteSupplementalSalarySuccess,
	ESupplementalSalaryActions,
	GetSupplementalSalaries,
	GetSupplementalSalariesSuccess,
	GetSupplementalSalary,
	GetSupplementalSalarySuccess,
	PatchSupplementalSalary,
	PatchSupplementalSalarySuccess,
	PostSupplementalSalary,
	PostSupplementalSalarySuccess,
} from '@app/core/store/actions/supplementalSalary.actions';
import {SupplementalSalaryService} from '@app/core/services/api/supplementalSalary.service';
import {PaginationHolder} from '@app/core/models/pagination.model';
import {SupplementalSalary} from '@app/core/models/supplementalSalary.model';
import {Router} from '@angular/router';

@Injectable()
export class SupplementalSalaryEffects {

	@Effect()
	public onGetSupplementalSalaries$ = this.actions$.pipe(
		ofType<GetSupplementalSalaries>(ESupplementalSalaryActions.GetSupplementalSalaries),
		switchMap((action: GetSupplementalSalaries) => from(this.supplementalSalaryService.getSupplementalSalaries(1, 300, action.filters).pipe(
			switchMap((res: PaginationHolder<SupplementalSalary>) => [
				new GetSupplementalSalariesSuccess(res.data, res.pagination),
			]),
			catchError(error => of(new LoadError(error, action))),
		))),
	);

	@Effect()
	public onGetSupplementalSalary$ = this.actions$.pipe(
		ofType<GetSupplementalSalary>(ESupplementalSalaryActions.GetSupplementalSalary),
		switchMap((action: GetSupplementalSalary) => from(this.supplementalSalaryService.getSupplementalSalary(action.id).pipe(
			switchMap((supplementalSalary: SupplementalSalary) => [
				new GetSupplementalSalarySuccess(supplementalSalary),
			]),
			catchError(error => of(new LoadError(error, action))),
		))),
	);

	@Effect()
	public onPostSupplementalSalary$ = this.actions$.pipe(
		ofType<PostSupplementalSalary>(ESupplementalSalaryActions.PostSupplementalSalary),
		switchMap((action: PostSupplementalSalary) => from(this.supplementalSalaryService.postSupplementalSalary(action.payload).pipe(
			switchMap((supplementalSalary) => {
				this.router.navigate(['/home/afdelingsindstillinger/salary/supplements']);

				return [
					new PostSupplementalSalarySuccess(supplementalSalary),
				];
			}),
			catchError(error => of(new LoadError(error, action))),
		))),
	);

	@Effect()
	public onPatchSupplementalSalary$ = this.actions$.pipe(
		ofType<PatchSupplementalSalary>(ESupplementalSalaryActions.PatchSupplementalSalary),
		switchMap((action: PatchSupplementalSalary) => from(this.supplementalSalaryService.patchSupplementalSalary(action.id, action.payload).pipe(
			switchMap((supplementalSalary) => {
				this.router.navigate(['/home/afdelingsindstillinger/salary/supplements']);

				return [
					new PatchSupplementalSalarySuccess(supplementalSalary),
				];
			}),
			catchError(error => of(new LoadError(error, action))),
		))),
	);

	@Effect()
	public onDeleteSupplementalSalary$ = this.actions$.pipe(
		ofType<DeleteSupplementalSalary>(ESupplementalSalaryActions.DeleteSupplementalSalary),
		switchMap((action: DeleteSupplementalSalary) => from(this.supplementalSalaryService.deleteSupplementalSalary(action.id).pipe(
			switchMap((supplementalSalary) => {
				this.router.navigate(['/home/afdelingsindstillinger/salary/supplements']);

				return [
					new DeleteSupplementalSalarySuccess(supplementalSalary),
				];
			}),
			catchError(error => of(new LoadError(error, action))),
		))),
	);

	constructor(
		private actions$: Actions,
		private router: Router,
		private supplementalSalaryService: SupplementalSalaryService,
	) {
	}
}
